'use strict';

var core = require('org_km/cart/cart');
var base = require('org_km/product/base');


//override updateCartTotals to trigger minicart's count:update
/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
core.updateCartTotals = function(data) {
    $('.number-of-items').empty().append(data.numItems == 1 ? data.resources.numberOfItem : data.resources.numberOfItems);
    $('.shipping-cost span').empty().append(data.totals.totalShippingCost);
    $('.tax-total span').empty().append(data.totals.totalTax);
    $('.grand-total span').empty().append(data.totals.grandTotalLessGiftCertificatePaymentInstrumentsFormatted);
    $('.js-grand-total').empty().append(data.totals.grandTotalLessGiftCertificatePaymentInstrumentsFormatted);
    $('.sub-total span').empty().append(data.totals.subTotal);
    var countUpdateObj = {};
    countUpdateObj.quantityTotal = data.numItems;
    countUpdateObj.minicartCountOfItems = data.resources.minicartCountOfItems;
    $('.minicart').trigger('count:update', countUpdateObj);
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total span').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    if (data.payment.giftCertificatePaymentInstruments.length) {
        $('.giftcertificate-discount').removeClass('d-none');
        $('.giftcertificate-discount-label').text(data.totals.giftCertificatePaymentInstrumentsLabel);
        $('.giftcertificate-discount-total').text('- ' + data.totals.giftCertificatePaymentInstrumentsTotalFormatted);
    } else {
        $('.giftcertificate-discount').addClass('d-none');
    }

    if (data.totals.grandTotalLessGiftCertificatePaymentInstrumentsValue) {
        $('.cartAdditionalPaymentButtons').removeClass('d-none');
    } else {
        $('.cartAdditionalPaymentButtons').addClass('d-none');
    }

    data.items.forEach(function (item) {
        var itemPrice;
        var itemTotalPrice;

        if (item.productType === 'giftCertificate') {
            itemPrice = item.priceTotal.price;
            itemTotalPrice = item.priceTotal.price;
        } else {
            itemPrice = item.renderedPrice;
            itemTotalPrice = item.priceTotal.renderedPrice;
        }

        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(itemPrice);
        $('.line-item-total-price-' + item.UUID).empty().append(itemTotalPrice);
        $('.item-total-' + item.UUID).text(item.totalTaxNoTaxQuantity);
        $('.line-item-price-info-' + item.UUID).text(item.totalTaxNoTaxQuantity);
    });

    $('.js-notax-items-price').text(data.totalPricesByTaxType.totalPriceWithoutTax);
    $('.js-tax-items-price').text(data.totalPricesByTaxType.totalPriceWithTax);
    $('.js-notax-items-qty').text(data.totalQtyProductWithoutTax);
    $('.js-tax-items-qty').text(data.totalQtyProductWithTax);
    $('.js-cart-total-qty').text(data.totalQuantity);
    $('.js-grand-total').text(data.totals.grandTotalLessGiftCertificatePaymentInstrumentsFormatted);
}

core.renderShippingMethods = function (html) {
    var $shippingMethodsSelect = $('#shippingMethods')
    $shippingMethodsSelect.replaceWith(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
core.updateAvailability = function(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes line-item-attributes-new">'
                    + '<span class="instock-square"></span> '
                    + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

core.init = function () {
    const ajaxRequest = (url, method, data, onSuccess, onError) => {
        $.ajax({
            url: url,
            method: method,
            data: data,
            dataType: 'json',
            success: onSuccess,
            error: onError || function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    console.error(err);
                    $.spinner().stop();
                }
            }
        });
    };

    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        const actionUrl = $(this).data('action');
        const productID = $(this).data('pid');
        const productName = $(this).data('name');
        const uuid = $(this).data('uuid');

        module.exports.confirmDelete(actionUrl, productID, productName, uuid);
    });

    const displayCartMessage = (response) => {
        const messageType = response.error ? 'alert-danger' : 'alert-success';

        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        $('.add-to-cart-messages').append(
            `<div class="alert ${messageType} add-to-basket-alert text-center" role="alert">
            ${response.message}
        </div>`
        );

        setTimeout(() => {
            $('.add-to-basket-alert').remove();
        }, 5000);
    };
    const addProductToCart = (addToCartUrl, pid, quantity, isTaxExempt) => {
        $('body').trigger('product:beforeAddToCart');

        const form = {
            pid: pid,
            quantity: quantity,
            isTaxExempt: isTaxExempt,
            options: null
        };

        if (addToCartUrl) {
            ajaxRequest(
                addToCartUrl,
                'POST',
                form,
                (data) => {
                    displayCartMessage(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $('body').trigger('product:afterAddToCartQuickview', data);
                    $.spinner().stop();
                    scope.methods.miniCartReportingUrl(data.reportingURL);
                },
                () => {
                    $.spinner().stop();
                }
            );
        }
    };
    const removeLineItemFromCart = (url, uuid) => {
        ajaxRequest(
            url,
            'GET',
            null,
            (data) => {
                if (data.basket.items.length === 0) {
                    $('.cart').empty()
                        .addClass('cart-empty')
                        .append(`
                        <div class="row">
                            <div class="col-12 text-center">
                                <h2>${data.basket.resources.emptyCartMsg}</h2>
                            </div>
                        </div>
                    `);

                    updateCartUI(data.basket);
                } else {
                    location.reload();
                    $.spinner().stop();
                }
                $.spinner().stop();
            },
            (err) => {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    module.exports.createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        );
    };
    const updateCartUI = (basket) => {
        $('.number-of-items').text(basket.resources.numberOfItems);
        $('.number-of-items-container').removeClass('text-md-right');
        $('.js-edit-button').addClass('d-none');

        const countUpdateObj = {
            quantityTotal: basket.numItems,
            minicartCountOfItems: basket.resources.minicartCountOfItems
        };

        $('.minicart').trigger('count:update', countUpdateObj);

        $('.minicart-link').attr({
            'aria-label': basket.resources.minicartCountOfItems,
            title: basket.resources.minicartCountOfItems
        });

        $('.minicart .popover').empty().removeClass('show');
        $('body').removeClass('modal-open');
        $('html').removeClass('veiled');
    };


    $('body').on('click', '.remove-tax-product', function (e) {
        e.preventDefault();

        const quantity = $(this).val();
        const $quantityForm = $(this).closest('.quantity-form');
        var row = $(this).closest(".tax-section");
        var withTaxQty = row.find(".with-tax input[name='qty-stepper']").val() || 0;
        var withoutTaxQty = row.find(".without-tax input[name='qty-stepper']").val() || 0;
        var url = $(this).data('action');
        const productID = $quantityForm.data('pid');
        const uuid = $quantityForm.data('uuid');
        const dataQty = $(this).data('qty');
        const isTaxExempt = $quantityForm.data('istaxexempt');
        const removeUrl = $quantityForm.data('removeaction');
        const minTaxQuantity = $quantityForm.find('.js-quantity-stepper').data('min');
        var urlParams = {
            pid: productID,
            uuid: uuid,
            quantity,
            uuid,
            isTaxExempt
        };

        url = module.exports.appendToUrl(url, urlParams);
        $('body').trigger('cart:beforeUpdate');

        // $.spinner().start();

        // Handle quantity 0: remove item from cart

        if(withTaxQty == minTaxQuantity && withoutTaxQty == 0 || withTaxQty == 0 && withoutTaxQty == minTaxQuantity) {
            $('.quantity-form').removeClass('clicked-btn');
            $quantityForm.addClass('clicked-btn');
            $('#removeProductModalQuantity').modal('show');
        } else if (quantity == 0){
            const finalRemoveUrl = module.exports.appendToUrl(removeUrl, urlParams);
                removeLineItemFromCart(finalRemoveUrl, uuid);
            return;
        }

    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        module.exports.confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid,
        };

        const finalRemoveUrl = module.exports.appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $('body').trigger('cart:beforeUpdate');

        $.spinner().start();


        removeLineItemFromCart(finalRemoveUrl, uuid);
    });

    $('body').on('click', '.cart-delete-confirmation-btn-quantity', function (e) {
        e.preventDefault();

        var clickedBtn = $('.clicked-btn');
        var productID = clickedBtn.data('pid');
        var url = clickedBtn.data('action');
        var uuid = clickedBtn.data('uuid');
        const isTaxExempt = clickedBtn.data('istaxexempt');
        const removeUrl = clickedBtn.data('removeaction');
        var urlParams = {
            pid: productID,
            uuid: uuid,
            uuid,
            isTaxExempt
        };

        const finalRemoveUrl = module.exports.appendToUrl(removeUrl, urlParams);

        $('body > .modal-backdrop').remove();

        $('body').trigger('cart:beforeUpdate');

        $.spinner().start();


        removeLineItemFromCart(finalRemoveUrl, uuid);
    });

    $('body').on('quantityStepper:change', (event, stepper) => {
        var $stepper = $(stepper);
        var isMiniCart = $stepper.closest('.minicart').length > 0;
        var selectId = $stepper.closest('.quantity-form').find('select').attr('id');
        var $select = $('.cart-page select#' + selectId);
        var value = parseInt($stepper.find('input').val());

        // if the qty change was triggered from the minicart, manually update cart qty input values
        if (isMiniCart) {
            var $cartStepper = $select.next('.quantity-stepper');
            $cartStepper.find('input').prop('value', value).prop('data-qty', value);
        }
    });

    $('body').on('change', '.product-info .quantity-stepper input, .quantity-form > .quantity-stepper input, .quantity-form > .requested-quantity', function () {
        const $quantityForm = $(this).closest('.quantity-form');
        const url = $quantityForm.data('action');
        const removeUrl = $quantityForm.data('removeaction');

        var row = $(this).closest(".tax-section");
        var withTaxQty = row.find(".with-tax input[name='qty-stepper']").val() || 0;
        var withoutTaxQty = row.find(".without-tax input[name='qty-stepper']").val() || 0;

        if (!url) return;

        const preSelectQty = $quantityForm.data('pre-select-qty');
        const quantity = $(this).val();
        const productID = $quantityForm.data('pid');
        const uuid = $quantityForm.data('uuid');
        const dataQty = $(this).data('qty');
        const isTaxExempt = $quantityForm.data('istaxexempt');
        const urlParams = { pid: productID, quantity, uuid, isTaxExempt };

        // Handle quantity 0: remove item from cart

        if(withTaxQty == 0 && withoutTaxQty == 0) {
            $('.quantity-form').removeClass('clicked-btn');
            $quantityForm.addClass('clicked-btn');
            $('#removeProductModalQuantity').modal('show');
        } else if (quantity == 0){
            const finalRemoveUrl = module.exports.appendToUrl(removeUrl, urlParams);
            removeLineItemFromCart(finalRemoveUrl, uuid);
            return;
        }

        // Handle adding product to cart
        if (dataQty == 0) {
            const actUrl = $(this).data('action');
            addProductToCart(actUrl, productID, quantity, isTaxExempt);
            return;
        }

        // Append URL parameters
        const finalUrl = module.exports.appendToUrl(url, urlParams);

        $quantityForm.parents('.card').spinner().start();
        $('body').trigger('cart:beforeUpdate');

        ajaxRequest(
            finalUrl,
            'GET',
            null,
            (data) => {
                handleQuantityUpdateSuccess(data, quantity, uuid, $quantityForm);
            },
            (err) => {
                handleQuantityUpdateError(err, preSelectQty, $quantityForm);
            }
        );
    });

    const handleQuantityUpdateSuccess = (data, quantity, uuid, $quantityForm) => {
        const minQty = $quantityForm.find('.quantity-stepper').data('min');
        const parentQty = $quantityForm.find('.js-quantity-stepper');

        toggleProductActions(quantity, minQty, parentQty);

        $(`.quantity[data-uuid="${uuid}"]`).val(quantity);

        if (data.totals?.discountsHtml) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }

        module.exports.updateCartTotals(data);
        module.exports.updateApproachingDiscounts(data.approachingDiscounts);
        module.exports.updateAvailability(data, uuid);
        module.exports.validateBasket(data);
        $quantityForm.data('pre-select-qty', quantity);

        $('body').trigger('cart:update', [data, uuid]);
        $.spinner().stop();

        handleSpecialCases(data, uuid, $quantityForm);
    };

    const toggleProductActions = (quantity, minQty, parentQty) => {
        if (quantity == minQty) {
            parentQty.find('.js-decrease-product').addClass('d-none');
            parentQty.find('.js-remove-tax-product').removeClass('d-none');
        } else {
            parentQty.find('.js-decrease-product').removeClass('d-none');
            parentQty.find('.js-remove-tax-product').addClass('d-none');
        }
    };

    const handleSpecialCases = (data, uuid, $quantityForm) => {
        const basketLineItem = data.items.find((item) => item.UUID === uuid);
        const isQuantityBackordered = Boolean(basketLineItem?.quantityOptions.quantityBackordered) && basketLineItem.quantityOptions.quantityBackordered > 0;

        if (isQuantityBackordered && !$quantityForm.find('.qty-requested-stepper').length) {
            location.reload();
        }

        if ($quantityForm.parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
            location.reload();
        }
    };

    const handleQuantityUpdateError = (err, preSelectQty, $quantityForm) => {
        if (err.responseJSON?.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
        } else {
            module.exports.createErrorNotification(err.responseJSON?.errorMessage);
            $quantityForm.find('input').val(parseInt(preSelectQty, 10));
            $.spinner().stop();
        }
    };

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = module.exports.appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    module.exports.updateCartTotals(data);
                    module.exports.updateApproachingDiscounts(data.approachingDiscounts);
                    module.exports.validateBasket(data);
                }
                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    module.exports.createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();

        var currentItemCount = parseInt($('.minicart-quantity').text(), 10) || 0;

        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                    $('.coupon-code-field').trigger('focus');
                    $.spinner().stop();
                } else {
                    // If cart item was added/removed via promo code submit
                    if (['', null, undefined].indexOf(data.basketModel.numItems) && currentItemCount !== data.basketModel.numItems) {

                        // Clean Url Structure of any erroneous parameters
                        if (window.history && ['', null, undefined].indexOf(data.basketModel.actionUrls.showUrl) === -1) {
                            history.replaceState({}, null, data.basketModel.actionUrls.showUrl);
                        }
                        // Force uncached reload
                        window.location.reload(true);
                    } else {
                        $('.coupons-and-promos').empty().append(data.basketModel.totals.discountsHtml);
                        module.exports.updateCartTotals(data.basketModel);
                        module.exports.updateApproachingDiscounts(data.basketModel.approachingDiscounts);
                        module.exports.validateBasket(data.basketModel);
                        $('body').trigger('promotion:success', data.basketModel);
                        $('.coupon-code-field').val('');
                        if (data.newBonusDiscountLineItem) {
                            base.methods.chooseBonusProducts(data.newBonusDiscountLineItem);
                        }
                        $.spinner().stop();
                    }
                }
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    module.exports.createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var currentItemCount = parseInt($('.minicart-quantity').text(), 10) || 0;
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = module.exports.appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();

                // If cart item was added/removed via promo code removal
                if (['', null, undefined].indexOf(data.numItems) && currentItemCount !== data.numItems) {
                    // Clean Url Structure of any erroneous parameters
                    if (window.history && ['', null, undefined].indexOf(data.actionUrls.showUrl) === -1) {
                        history.replaceState({}, null, data.actionUrls.showUrl);
                    }
                    // Force uncached reload
                    window.location.reload(true);
                } else {
                    module.exports.updateCartTotals(data);
                    module.exports.updateApproachingDiscounts(data.approachingDiscounts);
                    module.exports.validateBasket(data);
                    if (data.plisRemovedBonusDiscountLineItems && data.plisRemovedBonusDiscountLineItems.length > 0) {
                        data.plisRemovedBonusDiscountLineItems.forEach((uuid) => {
                            $(`.uuid-${uuid} .bonus-product-button`).remove();
                        });
                    }
                    $.spinner().stop();
                    $('body').trigger('promotion:success', data);
                }
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    module.exports.createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                $('body').trigger('bonusproduct:edit', data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('quantityStepper:change', function (e, qtyStepper) {
        let $modal = $('.modal.show .update-cart-url');
        if ($modal.length > 0) {
            var selectedQuantity = $(qtyStepper).find('input').val();
            $modal.data('quantity', selectedQuantity);
        }
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();
        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var form = $(this).closest('.cart-and-ipay').find('.update-cart-url').data();

        if (form) {
            form.selectedOptionValueIds = base.methods.getOptions($('#quickViewModal'));
            form.pid = module.exports.getPidValue($(this))
            $(this).parents('.card').spinner().start();
            $('body').trigger('cart:beforeUpdate');

            if (updateProductUrl) {
                $.ajax({
                    url: updateProductUrl,
                    type: 'post',
                    context: this,
                    data: form,
                    dataType: 'json',
                    success: function (data) {
                        $('#quickViewModal').modal('hide');

                        $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                        module.exports.updateCartTotals(data.cartModel);
                        module.exports.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                        module.exports.updateAvailability(data.cartModel, form.uuid);
                        module.exports.updateProductDetails(data, form.uuid);

                        if (data.uuidToBeDeleted) {
                            $('.uuid-' + data.uuidToBeDeleted).remove();
                        }

                        module.exports.validateBasket(data.cartModel);

                        $('body').trigger('cart:update', [data, form.uuid]);

                        if (data.shippingMethodSelectionHtml) {
                            module.exports.renderShippingMethods(data.shippingMethodSelectionHtml);
                        }

                        $.spinner().stop();
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            module.exports.createErrorNotification(err.responseJSON.errorMessage);
                            $.spinner().stop();
                        }
                    }
                });
            }
        }
    });

    $('body').on('product:afterAddToCartQuickview', () => {
        var verifyCartPage = $('body').find('.page').data('action');
        if (verifyCartPage == 'Checkout-Begin') {
            $('.promo-code-card-body').removeClass('d-lg-block');
            $('.js-submit-shipping').hide();
            location.reload();
        }
    });


    window.onpopstate = function() {
        var checkoutPage = $('body').find('.page').data('action');
        if (checkoutPage == 'Checkout-Begin') {
            location.reload();
        }
    }

    //responsible for filling edit gift cert modal with information from line item on cart page
    $('body').on('click', 'a.edit.editGiftCertificateLineItem', function (e) {
        e.preventDefault();

        var anchor = $(this);
        var uuid = anchor.data('uuid');
        var parentContainer = anchor.parents('.product-info.uuid-' + uuid);
        var from = parentContainer.find('.dwfrm_giftCertificate_purchase_from-' + uuid).data('value');
        var recipient = parentContainer.find('.dwfrm_giftCertificate_purchase_recipient-' + uuid).data('value');
        var recipientEmail = parentContainer.find('.dwfrm_giftCertificate_purchase_recipientEmail-' + uuid).data('value');
        var message = parentContainer.find('.dwfrm_giftCertificate_purchase_message-' + uuid).attr('title');
        var amount = parentContainer.find('.pricing.item-total-' + uuid).data('value');

        var modal = $('#editGiftCertificateLineItemModal');
        modal.find('#from').attr('value', from);
        modal.find('#recipient').attr('value', recipient);
        modal.find('#recipientEmail').attr('value', recipientEmail);
        modal.find('#confirmRecipientEmail').attr('value', recipientEmail);
        modal.find('#message').html(message || '');
        modal.find('#amount').attr('value', (('' + amount) || '0.0').split('.')[0]);
        modal.find('.btn-update-giftcertificate-incart').attr('data-uuid', uuid);
        modal.find('.btn-update-giftcertificate-incart').data('uuid', uuid);
    });

    $('body').on('cart:update', function (event, data) {
        var treeHtmlEntity = ' &#x1F333; ';
        var numberOfTreesSaved = data.numberOfTreesSaved || data.basket.numberOfTreesSaved || 0;
        var trees = treeHtmlEntity.repeat(numberOfTreesSaved);

        $('[data-select-trees-container]').html(trees)
    });
    const toggleVisibility = (showSelectors, hideSelectors) => {
        $(showSelectors).removeClass('d-none');
        $(hideSelectors).addClass('d-none');
    };

    $('body').on('click', '.js-edit-button', function (e) {
        e.preventDefault();
        toggleVisibility('.checked-field-wrapper, .js-cancel-edit-button, .js-edit-buttons', '.js-edit-button');
    });

    $('body').on('click', '.js-cancel-edit-button', function (e) {
        e.preventDefault();
        toggleVisibility('.js-edit-button', '.js-edit-buttons, .checked-field-wrapper, .js-cancel-edit-button');
    });

    $('body').on('click', '.js-selected-all-products', function (e) {
        e.preventDefault();
        const checkboxes = $('.custom-control-input');
        const shouldCheck = !checkboxes.is(':checked');

        if(shouldCheck) {
            $('.js-selected-with-tax').removeClass('currently-disabled');
            $('.js-selected-without-tax').removeClass('currently-disabled');
        } else {
            $('.js-selected-with-tax').addClass('currently-disabled');
            $('.js-selected-without-tax').addClass('currently-disabled');
        }
        checkboxes.prop('checked', shouldCheck);
    });


    $('.card.product-info .custom-control-input').change(function() {
        const checkboxes = $(this);
        const shouldCheck = checkboxes.is(':checked');

        if(shouldCheck) {
            $('.js-selected-with-tax').removeClass('currently-disabled');
            $('.js-selected-without-tax').removeClass('currently-disabled');
        } else {
            $('.js-selected-with-tax').addClass('currently-disabled');
            $('.js-selected-without-tax').addClass('currently-disabled');
        }
        checkboxes.prop('checked', shouldCheck);
    });

    const handleProductSelection = (triggerSelector, quantitySelector, callbackUrlKey) => {
        $('body').on('click', triggerSelector, function (e) {
            e.preventDefault();

            const selectedProducts = [];
            const url = $(this).data(callbackUrlKey);

            $('.card.product-info').each(function () {
                const checkbox = $(this).find('.custom-control-input');
                const productName = $(this).find('.line-item-name').text();
                const productQuantity = $(this).find(quantitySelector).val();
                const uuid = $(this).find(quantitySelector).data('uuid');
                const productID = $(this).find('.quantity-form').attr('data-pid');

                if (checkbox.is(':checked')) {
                    selectedProducts.push({ productName, productID, productQuantity, uuid });
                }
            });

            if (selectedProducts.length > 0) {
                $.ajax({
                    url: url,
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(selectedProducts),
                    dataType: 'json',
                    success: function (data) {
                        location.reload();
                    },
                    error: function (err) {
                        console.error(err);
                    }
                });
            }
        });
    };

    handleProductSelection('.js-selected-with-tax', '.without-tax [name="qty-stepper"]', 'url');
    handleProductSelection('.js-selected-without-tax', '.with-tax [name="qty-stepper"]', 'url');


    if ($('div.cart-page, div.checkout-page').length) {
        $('#maincontent').addClass('new-bg-design')
    }

    $('body').on('click', '.payment-options-block .nav-link', function(){
        $('.js-show-card-payment').removeClass('d-none');

        if($(this).hasClass('js-salesforce-card')) {
            $('.js-show-card-payment').addClass('card-info');
            $('.payment-form .next-step-button').removeClass('d-none');
        } else {
            $('.js-show-card-payment').removeClass('card-info');
            $('.payment-form .next-step-button').addClass('d-none');
        }

    });

    $('body').on('click', '.js-show-review-card', function(e){
        e.preventDefault();
        $(this).addClass('d-none');
        $('#checkout-main').addClass('on-review-section');
        $('.card.payment-summary.review-section-wrapper').addClass('d-block');
    });


    $('body').on('click', '.js-back-to-begin', function(e){
        e.preventDefault();
        $('.js-show-review-card').removeClass('d-none');
        $('#checkout-main').removeClass('on-review-section');
        $('.card.payment-summary.review-section-wrapper').removeClass('d-block');
    });

    $('body').on('click', '.js-invoice-show-details', function(e){
        e.preventDefault();
        $('#checkout-main').removeClass('on-review-section');
    });

    $('body').on('click', '.js-submit-shipping', function(){
        $('.js-show-review-card').removeClass('d-none');
    });


    $('body').on('click', '.js-show-payment-card', function(e){
        e.preventDefault();
        $(this).addClass('d-none');
        $('.js-show-review-card').addClass('d-none');
        $('.card.payment-summary.review-section-wrapper').removeClass('d-block');
        $('.payment-section-wrapper').removeClass('d-none');
        $('#checkout-main').removeClass('on-review-section');
        $('#checkout-main').addClass('on-payment-section');
    });

    $('body').on('click', '.js-back-to-review', function(e){
        e.preventDefault();
        $('.js-show-review-card').addClass('d-none');
        $('.js-show-payment-card').removeClass('d-none');
        $('.payment-section-wrapper').addClass('d-none');
        $('#checkout-main').removeClass('on-payment-section');
        $('#checkout-main').addClass('on-review-section');
        $('.card.payment-summary.review-section-wrapper').addClass('d-block');
    });

    $('.card.product-info').each(function () {
        var taxFlexible = $(this).hasClass('tax-flexible')

        if (taxFlexible) {
           $('.edit-button-section').removeClass('d-none');
        }
    });

    $(window).scroll(function(){
        const $title = $('.cart-page .cart-header');
        const $offset = $title.offset();
        const $screenPosition = $(document).scrollTop();
        if ($screenPosition && $offset && $screenPosition > $offset.top) {
            $($title).addClass('cart-sticky');
        }
    });

    $('body').on('click', '.clear-cart', function (e) {
        e.preventDefault();
        $('.cart-clear-confirmation-btn').data('action', $(this).data('action'));
    });

    $('body').on('click', '.cart-clear-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');

        $('body > .modal-backdrop').remove();

        $('body').trigger('cart:beforeUpdate');

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.cart').empty().append(
                    `<div class="row">
                        <div class="col-12 text-center">
                            <h2>${data.basket.resources.emptyCartMsg}</h2>
                        </div>
                    </div>
                    `
                );
                $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                $('.number-of-items-container').removeClass('text-md-right');
                $('.minicart-quantity').empty().append(data.basket.numItems);
                $('.minicart-link').attr({
                    'aria-label': data.basket.resources.minicartCountOfItems,
                    title: data.basket.resources.minicartCountOfItems
                });
                $('body').removeClass('modal-open');
                $('html').removeClass('veiled');
                $('.clear-cart, .js-edit-button').addClass('d-none');
                $('.cart-page .cart').addClass('cart-empty');

                $('body').trigger('cart:update', [data]);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    module.exports.createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });


    $('.card.product-info').each(function () {
        const promotion = $(this).find('.line-item-promo > div');
        const promotionText = promotion.find('div');

        if (promotion.length > 0) {
            var text = promotion.text();

            $('.promo-code-card-body .product-promotion-side').append('<p>' + text + '</p>');
        }
    });
}

module.exports = core;
